import {
    CartContainerItemFragment,
    CartContainerItemsFragment as CartContainerItemsFragmentType,
    CartFragment as CartFragmentType,
    CartItemFragment,
    CartItemsFragment as CartItemsFragmentType,
} from '@/features/graphql/generated/graphql'
import {
    CartContainerItemsFragment,
    CartFragment,
    CartItemsFragment,
} from '@/features/pos/components/Cart/fragments/cart'
import { CartQuery } from '@/features/pos/components/Cart/queries'
import type { ApolloCache } from '@apollo/client'

export const getCartFromCache = (
    cache: ApolloCache<object>,
    key: string
): CartFragmentType | null => {
    return cache.readFragment({
        id: cache.identify({ __typename: 'Cart', key }),
        fragment: CartFragment,
        fragmentName: 'Cart',
    })
}

export const writeCartItemsToCache = (
    cache: ApolloCache<object>,
    key: string,
    items: CartItemFragment[]
): void => {
    cache.writeFragment({
        fragment: CartItemsFragment,
        fragmentName: 'CartItems',
        data: { __typename: 'Cart', key, items } satisfies CartItemsFragmentType,
    })
}

export const writeCartContainerItemsToCache = (
    cache: ApolloCache<object>,
    key: string,
    containerItems: CartContainerItemFragment[]
): void => {
    cache.writeFragment({
        fragment: CartContainerItemsFragment,
        fragmentName: 'CartContainerItems',
        data: {
            __typename: 'Cart',
            key,
            containerItems,
        } satisfies CartContainerItemsFragmentType,
    })
}

export const writeCartQueryToCache = (
    cache: ApolloCache<object>,
    key: string,
    items: CartItemFragment[],
    containerItems: CartContainerItemFragment[]
): void => {
    cache.writeQuery({
        query: CartQuery,
        variables: { cartKey: key },
        data: { cart: { __typename: 'Cart', key, items, containerItems } },
    })
}
